module.exports = __webpack_public_path__ + "static/img/page17.d9d278a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page17.jpg
// module id = kt8d
// module chunks = 0